import React from 'react'

function CalculatorResults({ children }) {
  return (
    <div className="calculator-results">
      {children}
    </div>
  )
}

export default CalculatorResults



// WEBPACK FOOTER //
// ./src/components/CalculatorResults/index.js